import type { ContentFlagContentType } from "src/types/content-flag";

import { Label } from "src/components/label";

export function ContentTypeLabel({ contentType }: { contentType: ContentFlagContentType }) {
  return (
    <Label color="warning" variant="soft" sx={{ textTransform: "capitalize" }}>
      {contentType}
    </Label>
  );
}